import { motion, AnimatePresence } from "framer-motion";
import { Crosshair, Sprout, Brain, ToggleLeft, ToggleRight } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { HuntProgress } from "@/components/HuntProgress";
import { ActionButton } from "./ActionButton";

// One Hunt/Farm action: big button + Auto/Custom toggle + optional prompt textarea.
const ModeAction = ({ id, icon, color, title, autoLabel, autoSubtitle, placeholder, mode, setMode, prompt, setPrompt, processing, disabled, pendingCount, onRun, children }) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <ActionButton
        onClick={onRun}
        disabled={disabled}
        processing={processing}
        icon={icon}
        color={color}
        title={title}
        subtitle={pendingCount > 0 ? `${pendingCount} leads need disposition` : mode === "auto" ? autoSubtitle : "Search with custom prompt"}
        testId={`${id}-btn`}
      />
    </div>
    <div className="pl-2">
      <div className="flex items-center gap-2 mb-2">
        <button
          onClick={() => setMode(mode === "auto" ? "prompt" : "auto")}
          className="flex items-center gap-2 text-xs text-gray-400 hover:text-white transition-colors"
          data-testid={`${id}-mode-toggle`}
        >
          {mode === "auto" ? <ToggleLeft className={`h-4 w-4 ${id === "hunt" ? "text-ism-teal" : "text-gray-400"}`} /> : <ToggleRight className="h-4 w-4 text-ism-teal" />}
          <span>{mode === "auto" ? autoLabel : "Custom Prompt"}</span>
        </button>
      </div>
      <AnimatePresence>
        {mode === "prompt" && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}>
            <Textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder={placeholder}
              className="bg-white/5 border-ism-teal/30 text-white placeholder:text-gray-500 rounded-lg text-sm min-h-[60px] resize-none"
              data-testid={`${id}-prompt-input`}
            />
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </div>
  </div>
);

export const HuntFarmControls = ({ hunt, farm, advisor }) => (
  <div className="space-y-4 mb-6 relative z-10">
    <ModeAction id="hunt" icon={Crosshair} color="green" title="Hunt" autoLabel="Auto (ICP)" autoSubtitle="Generate leads from your ICP"
      placeholder="Describe the prospects you would like to find..." {...hunt}>
      {hunt.processing && <HuntProgress job={hunt.job} />}
    </ModeAction>
    <ModeAction id="farm" icon={Sprout} color="blue" title="Farm" autoLabel="Auto (Accounts)" autoSubtitle="Find opportunities in accounts"
      placeholder="Describe the expansion opportunities you're looking for..." {...farm} />
    <ActionButton
      onClick={advisor.onToggle}
      disabled={advisor.processing}
      processing={advisor.processing}
      icon={Brain}
      color="purple"
      title="Advisor"
      subtitle="Chat with sales strategy expert"
      testId="advisor-btn"
    />
  </div>
);
